export default __webpack_public_path__ + "static/media/silver-wheel-two.053e253d.svg";